export default "__VITE_ASSET__7cada5ac__"